function UploadVideo({ videoURL, videoFile }) {
  if (!videoFile) {
    return (
      <div>
        {videoURL && (
          <div>
            <video src={videoURL} width="750" height="450" controls>
              Your browser does not support the video tag.
            </video>
          </div>
        )}
      </div>
    );
  }
    return (
      <div>
        {videoURL && (
          <div>
            <video key={videoURL} width="750" height="450" controls>
              <source src={videoURL} type={videoFile?.type} />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
      </div>
    );
  }
  
  export default UploadVideo;